export default __webpack_public_path__ + "static/media/responsive-ecosystem.be11d283.png";